import { NgModule } from '@angular/core';
import { AppComponent, BaseWebModule } from 'web';
import { environment } from '../environments/environment';
import { I18nModule } from './i18n.module';

@NgModule({
  imports: [BaseWebModule.forRoot(environment), I18nModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
